import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { SectionHeading, GoldButton } from "@/components/Brand";
import SmartImage from "@/components/SmartImage";

const SERVICES = [
  ["event", "Fotografía de Eventos", "Event Photography",
    "Cobertura completa de su evento con entrega en galería digital.",
    "Complete coverage of your event delivered in a digital gallery.",
    "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"],
  ["reunion", "Fotografía de Reuniones", "Reunion Photography",
    "Retratos de grupo, momentos espontáneos y video para reencuentros.",
    "Group portraits, candid moments and video for reunions.",
    "https://images.unsplash.com/photo-1531844251246-9a1bfaae09fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"],
  ["graduation", "Fotografía de Graduación", "Graduation Photography",
    "Sesiones individuales y de familia para celebrar el logro.",
    "Individual and family sessions to celebrate the achievement.",
    "https://images.unsplash.com/photo-1618355776464-8666794d2520?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"],
  ["portrait", "Sesiones de Retrato", "Portrait Sessions",
    "Retrato en estudio o luz natural, con dirección y cuidado.",
    "Studio or natural-light portraiture with careful direction.",
    "https://images.unsplash.com/photo-1759021997600-57bc4d42c4ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"],
  ["family", "Eventos Familiares", "Family Events",
    "Bautizos, cumpleaños y celebraciones familiares.",
    "Baptisms, birthdays and family celebrations.",
    "https://images.pexels.com/photos/6030228/pexels-photo-6030228.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"],
  ["digital", "Galerías Digitales", "Digital Galleries",
    "Galerías privadas con descargas y permisos configurables.",
    "Private galleries with configurable downloads and permissions.",
    "https://images.unsplash.com/photo-1746587224861-521244472226?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"],
  ["restoration", "Restauración de Fotos", "Photo Restoration",
    "Recuperación y digitalización de fotografías antiguas.",
    "Recovery and digitization of vintage photographs.",
    "https://images.unsplash.com/photo-1655543256345-e4e4064667a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"],
  ["custom", "Paquetes Personalizados", "Custom Photo Packages",
    "Paquetes de impresión y digitales adaptados a su evento.",
    "Print and digital packages tailored to your event.",
    "https://images.pexels.com/photos/12954015/pexels-photo-12954015.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"],
];

export default function Services() {
  const { t, path, lang } = useI18n();
  const [custom, setCustom] = useState({});

  useEffect(() => {
    api.get("/site/home").then((r) => setCustom(r.data.service_images || {})).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-[1500px] px-4 py-14 sm:px-8 lg:px-12 lg:py-20" data-testid="services-page">
      <SectionHeading label="HR Creations" title={t("services.title")} sub={t("services.sub")} />
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {SERVICES.map(([key, es, en, dEs, dEn, img]) => (
          <article
            key={key}
            data-testid={`service-card-${key}`}
            className="flex flex-col overflow-hidden border border-[#C69A3B]/30 bg-white"
          >
            <div className="photo-hover aspect-[3/2] overflow-hidden">
              <SmartImage
                src={custom[key] || img}
                alt={lang === "es" ? es : en}
                loading="lazy"
                className="h-full w-full"
              />
            </div>
            <div className="flex flex-1 flex-col p-6">
              <h3 className="font-serif-display text-lg text-[#252525]">{lang === "es" ? es : en}</h3>
              <p className="mt-3 text-sm text-[#5A5752]">{lang === "es" ? dEs : dEn}</p>
              <p className="label-mono mt-5">{t("services.pricingSoon")}</p>
              <GoldButton
                as={Link}
                to={key === "restoration" ? path("restoration") : path("contact")}
                variant="outline"
                className="mt-5 w-fit"
                data-testid={`service-inquiry-${key}`}
              >
                {key === "restoration" ? `${t("restoration.title")} →` : t("services.inquire")}
              </GoldButton>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
